"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnavailableChallenges = exports.ChallengeOrchestrationErrorData = exports.DeniedData = exports.ChallengeOrchestrationRequestHeader = exports.ChallengeOrchestrationErrorData_ErrorCode = exports.DeniedData_ErrorCode = exports.IntegrityChallengeType = exports.CommunicationChannel = exports.ChallengeType = void 0;
/* eslint-disable */
const minimal_1 = __importDefault(require("protobufjs/minimal"));
/** The types of challenges we support */
var ChallengeType;
(function (ChallengeType) {
    /** CHALLENGE_TYPE_UNSET - default value */
    ChallengeType[ChallengeType["CHALLENGE_TYPE_UNSET"] = 0] = "CHALLENGE_TYPE_UNSET";
    /** PASSWORD - No delivery mechanism. */
    ChallengeType[ChallengeType["PASSWORD"] = 1] = "PASSWORD";
    /**
     * SECURITY_QUESTION - No delivery mechanism.
     * Deprecated: Do not use this. Use the specific security question enum types,
     * such as SECURITY_QUESTION_PHONE_NUMBER or SECURITY_QUESTION_EMAIL, instead.
     *
     * @deprecated
     */
    ChallengeType[ChallengeType["SECURITY_QUESTION"] = 2] = "SECURITY_QUESTION";
    /** OTP - One Time Password/Pin - Can be delivered via SMS or Email */
    ChallengeType[ChallengeType["OTP"] = 3] = "OTP";
    /** TIV - Transaction Intent Verification - Can be delivered via SMS, Email or Push */
    ChallengeType[ChallengeType["TIV"] = 4] = "TIV";
    /** TWO_FA - Two Factor Authentication - Can be delivered via SMS or TOTP (authenticator app) */
    ChallengeType[ChallengeType["TWO_FA"] = 5] = "TWO_FA";
    /** INTERNAL_IDENTITY_VERIFICATION - Internal Identity Verification - no delivery mechanism */
    ChallengeType[ChallengeType["INTERNAL_IDENTITY_VERIFICATION"] = 6] = "INTERNAL_IDENTITY_VERIFICATION";
    /** COMMUNICATION_CHANNEL_VERIFICATION - Communication Ch Verification - Can be delivered via Email */
    ChallengeType[ChallengeType["COMMUNICATION_CHANNEL_VERIFICATION"] = 7] = "COMMUNICATION_CHANNEL_VERIFICATION";
    /** SECURITY_QUESTION_PHONE_NUMBER - Phone number security question - delivered in band. */
    ChallengeType[ChallengeType["SECURITY_QUESTION_PHONE_NUMBER"] = 8] = "SECURITY_QUESTION_PHONE_NUMBER";
    /** SECURITY_QUESTION_EMAIL - Email security question - delivered in band. */
    ChallengeType[ChallengeType["SECURITY_QUESTION_EMAIL"] = 9] = "SECURITY_QUESTION_EMAIL";
    /** SECURITY_QUESTION_BIRTHDATE - Birthdate security question - delivered in band. */
    ChallengeType[ChallengeType["SECURITY_QUESTION_BIRTHDATE"] = 10] = "SECURITY_QUESTION_BIRTHDATE";
    /** SECURITY_QUESTION_USERNAME - Username security question - delivered in band. */
    ChallengeType[ChallengeType["SECURITY_QUESTION_USERNAME"] = 11] = "SECURITY_QUESTION_USERNAME";
    ChallengeType[ChallengeType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ChallengeType = exports.ChallengeType || (exports.ChallengeType = {}));
/** communication channels that we support */
var CommunicationChannel;
(function (CommunicationChannel) {
    /** COMMUNICATION_CHANNEL_UNSET - default value */
    CommunicationChannel[CommunicationChannel["COMMUNICATION_CHANNEL_UNSET"] = 0] = "COMMUNICATION_CHANNEL_UNSET";
    /** SMS - Delivered over SMS (OTP or TIV) */
    CommunicationChannel[CommunicationChannel["SMS"] = 1] = "SMS";
    /** EMAIL - Delivered over Email (OTP or TIV) */
    CommunicationChannel[CommunicationChannel["EMAIL"] = 2] = "EMAIL";
    /** PUSH - Delivered via Push */
    CommunicationChannel[CommunicationChannel["PUSH"] = 3] = "PUSH";
    /** TOTP - Time-based One Time Password/Pin - Generated on an authenticator app */
    CommunicationChannel[CommunicationChannel["TOTP"] = 4] = "TOTP";
    /** IN_BAND - In-band communication channel - Used for Password ChallengeType */
    CommunicationChannel[CommunicationChannel["IN_BAND"] = 5] = "IN_BAND";
    CommunicationChannel[CommunicationChannel["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CommunicationChannel = exports.CommunicationChannel || (exports.CommunicationChannel = {}));
/** vendor integrity challenge type */
var IntegrityChallengeType;
(function (IntegrityChallengeType) {
    /** INTEGRITY_CHALLENGE_TYPE_UNSET - unset challenge type */
    IntegrityChallengeType[IntegrityChallengeType["INTEGRITY_CHALLENGE_TYPE_UNSET"] = 0] = "INTEGRITY_CHALLENGE_TYPE_UNSET";
    /** CHALLENGE_TYPE_SAFETY_NET - google safety net challenge */
    IntegrityChallengeType[IntegrityChallengeType["CHALLENGE_TYPE_SAFETY_NET"] = 1] = "CHALLENGE_TYPE_SAFETY_NET";
    /** CHALLENGE_TYPE_PLAY_INTEGRITY_STANDARD - Play integrity standard challenge */
    IntegrityChallengeType[IntegrityChallengeType["CHALLENGE_TYPE_PLAY_INTEGRITY_STANDARD"] = 2] = "CHALLENGE_TYPE_PLAY_INTEGRITY_STANDARD";
    /** CHALLENGE_TYPE_PLAY_INTEGRITY_CLASSIC - Play integrity classic challenge */
    IntegrityChallengeType[IntegrityChallengeType["CHALLENGE_TYPE_PLAY_INTEGRITY_CLASSIC"] = 3] = "CHALLENGE_TYPE_PLAY_INTEGRITY_CLASSIC";
    /** CHALLENGE_TYPE_ANDROID_KEY_ATTESTATION - Android Key attestation challenge */
    IntegrityChallengeType[IntegrityChallengeType["CHALLENGE_TYPE_ANDROID_KEY_ATTESTATION"] = 4] = "CHALLENGE_TYPE_ANDROID_KEY_ATTESTATION";
    /** CHALLENGE_TYPE_SYSINTEGRITY - Huawei sysintegrity challenge */
    IntegrityChallengeType[IntegrityChallengeType["CHALLENGE_TYPE_SYSINTEGRITY"] = 5] = "CHALLENGE_TYPE_SYSINTEGRITY";
    IntegrityChallengeType[IntegrityChallengeType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(IntegrityChallengeType = exports.IntegrityChallengeType || (exports.IntegrityChallengeType = {}));
/** values for machine-readable error codes */
var DeniedData_ErrorCode;
(function (DeniedData_ErrorCode) {
    /** UNSET - default value */
    DeniedData_ErrorCode[DeniedData_ErrorCode["UNSET"] = 0] = "UNSET";
    /** RATE_LIMITED - Request is rate limited. Recommended action is rejecting the request with 429 response code if applicable. */
    DeniedData_ErrorCode[DeniedData_ErrorCode["RATE_LIMITED"] = 1] = "RATE_LIMITED";
    DeniedData_ErrorCode[DeniedData_ErrorCode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(DeniedData_ErrorCode = exports.DeniedData_ErrorCode || (exports.DeniedData_ErrorCode = {}));
/** values for machine-readable error codes */
var ChallengeOrchestrationErrorData_ErrorCode;
(function (ChallengeOrchestrationErrorData_ErrorCode) {
    /** UNSET - default value */
    ChallengeOrchestrationErrorData_ErrorCode[ChallengeOrchestrationErrorData_ErrorCode["UNSET"] = 0] = "UNSET";
    /** FAILED_CHALLENGE_INCORRECT_PASSWORD - an incorrect password was provided */
    ChallengeOrchestrationErrorData_ErrorCode[ChallengeOrchestrationErrorData_ErrorCode["FAILED_CHALLENGE_INCORRECT_PASSWORD"] = 1] = "FAILED_CHALLENGE_INCORRECT_PASSWORD";
    /** FAILED_CHALLENGE_INVALID_CODE - an incorrect code was provided */
    ChallengeOrchestrationErrorData_ErrorCode[ChallengeOrchestrationErrorData_ErrorCode["FAILED_CHALLENGE_INVALID_CODE"] = 2] = "FAILED_CHALLENGE_INVALID_CODE";
    /** FAILED_CHALLENGE_INVALID_CODE_LENGTH - a code with invalid length was provided */
    ChallengeOrchestrationErrorData_ErrorCode[ChallengeOrchestrationErrorData_ErrorCode["FAILED_CHALLENGE_INVALID_CODE_LENGTH"] = 3] = "FAILED_CHALLENGE_INVALID_CODE_LENGTH";
    /** FAILED_CHALLENGE_EMAIL_TAKEN - email is taken (already verified on another account); used for CommunicationChannelVerification challenges */
    ChallengeOrchestrationErrorData_ErrorCode[ChallengeOrchestrationErrorData_ErrorCode["FAILED_CHALLENGE_EMAIL_TAKEN"] = 4] = "FAILED_CHALLENGE_EMAIL_TAKEN";
    /** FAILED_CHALLENGE_INVALID_EMAIL - invalid email (due to formatting); used for CommunicationChannelVerification challenges */
    ChallengeOrchestrationErrorData_ErrorCode[ChallengeOrchestrationErrorData_ErrorCode["FAILED_CHALLENGE_INVALID_EMAIL"] = 5] = "FAILED_CHALLENGE_INVALID_EMAIL";
    ChallengeOrchestrationErrorData_ErrorCode[ChallengeOrchestrationErrorData_ErrorCode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ChallengeOrchestrationErrorData_ErrorCode = exports.ChallengeOrchestrationErrorData_ErrorCode || (exports.ChallengeOrchestrationErrorData_ErrorCode = {}));
function createBaseChallengeOrchestrationRequestHeader() {
    return {
        blizzardClientId: "",
        persistentAttestationDeviceId: "",
        clientCookieId: "",
    };
}
exports.ChallengeOrchestrationRequestHeader = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.blizzardClientId !== "") {
            writer.uint32(10).string(message.blizzardClientId);
        }
        if (message.persistentAttestationDeviceId !== "") {
            writer.uint32(18).string(message.persistentAttestationDeviceId);
        }
        if (message.clientCookieId !== "") {
            writer.uint32(26).string(message.clientCookieId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChallengeOrchestrationRequestHeader();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.blizzardClientId = reader.string();
                    break;
                case 2:
                    message.persistentAttestationDeviceId = reader.string();
                    break;
                case 3:
                    message.clientCookieId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseChallengeOrchestrationRequestHeader();
        message.blizzardClientId = object.blizzardClientId ?? "";
        message.persistentAttestationDeviceId =
            object.persistentAttestationDeviceId ?? "";
        message.clientCookieId = object.clientCookieId ?? "";
        return message;
    },
};
function createBaseDeniedData() {
    return { humanReadableMessage: "", errorCode: 0 };
}
exports.DeniedData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.humanReadableMessage !== "") {
            writer.uint32(10).string(message.humanReadableMessage);
        }
        if (message.errorCode !== 0) {
            writer.uint32(16).int32(message.errorCode);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeniedData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.humanReadableMessage = reader.string();
                    break;
                case 2:
                    message.errorCode = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseDeniedData();
        message.humanReadableMessage = object.humanReadableMessage ?? "";
        message.errorCode = object.errorCode ?? 0;
        return message;
    },
};
function createBaseChallengeOrchestrationErrorData() {
    return { humanReadableErrorMessage: "", errorCode: 0 };
}
exports.ChallengeOrchestrationErrorData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.humanReadableErrorMessage !== "") {
            writer.uint32(10).string(message.humanReadableErrorMessage);
        }
        if (message.errorCode !== 0) {
            writer.uint32(16).int32(message.errorCode);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChallengeOrchestrationErrorData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.humanReadableErrorMessage = reader.string();
                    break;
                case 2:
                    message.errorCode = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseChallengeOrchestrationErrorData();
        message.humanReadableErrorMessage = object.humanReadableErrorMessage ?? "";
        message.errorCode = object.errorCode ?? 0;
        return message;
    },
};
function createBaseUnavailableChallenges() {
    return { challengeTypes: [], communicationChannels: [] };
}
exports.UnavailableChallenges = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.challengeTypes) {
            writer.int32(v);
        }
        writer.ldelim();
        writer.uint32(18).fork();
        for (const v of message.communicationChannels) {
            writer.int32(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUnavailableChallenges();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.challengeTypes.push(reader.int32());
                        }
                    }
                    else {
                        message.challengeTypes.push(reader.int32());
                    }
                    break;
                case 2:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.communicationChannels.push(reader.int32());
                        }
                    }
                    else {
                        message.communicationChannels.push(reader.int32());
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseUnavailableChallenges();
        message.challengeTypes = object.challengeTypes?.map((e) => e) || [];
        message.communicationChannels =
            object.communicationChannels?.map((e) => e) || [];
        return message;
    },
};
//# sourceMappingURL=challenge_orchestration_common.js.map